import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { THEME } from './theme';

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <>
        {/* Static hosting serves 200 for every route, so an unknown blog URL is a soft 404:
            Google sees a successful response and can keep the URL indexed. noindex is the
            only signal available without SSR. */}
        <Helmet>
            <meta name="robots" content="noindex, follow" />
            <title>Blog Post Not Found | Marter</title>
        </Helmet>
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
            pt: THEME.spacing.headerOffset
        }}>
            <Container maxWidth="md">
                <Box sx={{
                    textAlign: 'center',
                    py: 8
                }}>
                    <Typography variant="h1" sx={{
                        fontSize: { xs: '4rem', md: '6rem' },
                        fontWeight: 800,
                        color: THEME.colors.primary,
                        mb: 2
                    }}>
                        404
                    </Typography>
                    <Typography variant="h2" sx={{
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        fontWeight: 700,
                        color: THEME.colors.text.primary,
                        mb: 3
                    }}>
                        Blog Post Not Found
                    </Typography>
                    <Typography variant="body1" sx={{
                        color: THEME.colors.text.secondary,
                        mb: 4,
                        fontSize: '1.1rem'
                    }}>
                        The blog post you're looking for doesn't exist or has been moved.
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate('/blogs')}
                        sx={{
                            bgcolor: THEME.colors.primary,
                            color: THEME.colors.text.primary,
                            px: 4,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: '#e6b800',
                                transform: 'translateY(-2px)',
                                boxShadow: THEME.shadows.yellow
                            }
                        }}
                    >
                        View All Blogs
                    </Button>
                </Box>
            </Container>
        </Box>
        </>
    );
}